import BUIDLTokenAbi from "./abis/buidlToken";
import ERC20Abi from "./abis/erc20";
import factoryAbi from "./abis/factory";
import starterInfoAbi from "./abis/starterInfo";
import starterStakingAbi from "./abis/starterStaking";
import starterPresaleAbi from "./abis/starterPresale";
import vestingAbi from "./abis/vesting";
import vestTokenAbi from "./abis/vest";
import swapRouterAbi from "./abis/swapRouter";

const config = {
  BUIDLTokenAddress: "0x1fc09bC5355C77Fa9925c614223360b1d8cDE673",
  BUIDLTokenAbi,
  ERC20Abi,
  factoryAbi,
  factoryAddress: "0xb7a4B9E2C2877EeD2E306D8A200692f120daE931",

  starterInfoAddress: "0x4c575528E32b2D639Def5408839144dff7091009",
  starterInfoAbi,

  starterStaking: "0xE3dB3b7c0e83799d63B56640adea950C34dc5643",
  starterStakingAbi,

  vestingAddress: "0x3C24256B2cE30c88c29cc57e273958038B62222a",
  vestingAbi,
  vestToken: "0x22f6c963e3da212e050da4852c472988dab52f31",
  vestTokenAbi,
  starterVestingAddress: "0x0e7b582003de0E541548cF02a1F00725Df6E6E6f", //0xE8759dC246eF451d763a12d4e79244627507BD7F LockOnBase on mainnet

  wethAddress: "0x4200000000000000000000000000000000000006",
  stakingToken: "0x1fc09bC5355C77Fa9925c614223360b1d8cDE673",
  stakingTokenName: "FAIR",
  stakingContracts: ["0xE3dB3b7c0e83799d63B56640adea950C34dc5643"],
  swapSymbol: "ETH",
  swapToken: "0x4200000000000000000000000000000000000006",
  swapTokenAbi: ERC20Abi,
  swapRouter: "0x327Df1E6de05895d2ab08513aaDD9313Fe505d86",
  swapRouterAbi,

  starterPresaleAbi,
};

export default config;
